import { render, staticRenderFns } from "./TextBanner.vue?vue&type=template&id=a2248592"
import script from "./TextBanner.vue?vue&type=script&lang=js"
export * from "./TextBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports